import { render, staticRenderFns } from "./allProdReviews.vue?vue&type=template&id=2165c5f2&"
import script from "./allProdReviews.vue?vue&type=script&lang=js&"
export * from "./allProdReviews.vue?vue&type=script&lang=js&"
import style0 from "./allProdReviews.vue?vue&type=style&index=0&id=2165c5f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports